// Otvorene stavke partnera - zajednicko za ekran, pdf i Excel.
//
// Dokumenti dolaze iz /zatvaranja/stanje (isti izracun kao ekran Zatvaranje
// stavaka): svaki ima jeRacun, iznos, zatvoreno i otvoreno. Ovdje se od njih
// slazu redci koje prikazuju Par.Otvoreno, Svi part.otv. i njihovi ispisi, da
// ekran i papir uvijek racunaju isto.
//
// Predznak: racun povecava saldo, uplata ga smanjuje. Saldo je dakle "koliko
// partner jos duguje" (kupci) ili "koliko mi jos dugujemo" (dobavljaci), a
// strana D/P odredjuje se prema kontu - vidi oznakaSalda.

import dayjs from 'dayjs'

const DAN = 24 * 60 * 60 * 1000

export const n2 = (v) => Math.round((parseFloat(v) || 0) * 100) / 100

// Na 12xx racun je na duguje, na 22xx na potrazuje.
export const racuniNaDuguje = (konto) => String(konto || '').substring(0, 2) !== '22'

export const oznakaSalda = (saldo, naDuguje) => {
  if (Math.abs(saldo) < 0.005) { return '' }
  return (saldo > 0) === naDuguje ? 'D' : 'P'
}

// Razredi dospijeca - iste granice kao /zatvaranja/otvorenepartneri.
export const RAZREDI = [
  {k: 'nedospjelo', naziv: 'Nedospjelo', kratko: 'Nedospjelo'},
  {k: 'd1_30', naziv: '1–30 dana', kratko: '1–30'},
  {k: 'd31_60', naziv: '31–60 dana', kratko: '31–60'},
  {k: 'd61_90', naziv: '61–90 dana', kratko: '61–90'},
  {k: 'preko90', naziv: 'više od 90 dana', kratko: '>90'}
]

export const razred = (dana) => {
  if (dana === null || dana <= 0) { return 'nedospjelo' }
  if (dana <= 30) { return 'd1_30' }
  if (dana <= 60) { return 'd31_60' }
  if (dana <= 90) { return 'd61_90' }
  return 'preko90'
}

// 1 uplata, 2-4 uplate, 5+ uplata; 11-14 uvijek kao 5+.
export const mnozina = (n, jedan, dva, pet) => {
  const d = n % 10
  const s = n % 100
  if (d === 1 && s !== 11) { return jedan }
  if (d >= 2 && d <= 4 && (s < 12 || s > 14)) { return dva }
  return pet
}

const datumTekst = (d) => (d ? dayjs(d).format('DD.MM.YYYY') : '')

const oznakaDokumenta = (d) => {
  const book = d.BookName ? String(d.BookName) : ''
  const broj = d.BookID ? parseInt(d.BookID) : ''
  if (book === 'BS') { return ('Izv. ' + broj).trim() }
  return (book + ' ' + broj).trim()
}

// Broj racuna na koji se dokument odnosi, s godinom racuna.
const vezaDokumenta = (d) => {
  const inNr = d.invoiceInNumber ? String(d.invoiceInNumber).trim() : ''
  const outNr = d.invoiceOutNumber ? String(d.invoiceOutNumber).trim() : ''
  let broj = String(d.account4 || '').substring(0, 2) === '12' ? outNr : inNr
  if (!broj || broj === '0') { broj = outNr && outNr !== '0' ? outNr : (inNr !== '0' ? inNr : '') }
  if (!broj || broj === '0') { return '' }
  return broj + (d.BusinessYearInvoice ? '/' + d.BusinessYearInvoice : '')
}

// Dani od dospijeca do datuma stanja; pozitivno znaci da je rok prosao. Isti
// racun kao na serveru, da se razredi na ekranu i u zbroju partnera slazu.
export const danaOdDospijeca = (d, doDatuma) => {
  if (!d.InvoicePaymentDeadlineDate) { return null }
  const na = doDatuma ? new Date(doDatuma) : new Date()
  return Math.floor((na - new Date(d.InvoicePaymentDeadlineDate)) / DAN)
}

/**
 * Otvoreni dokumenti kao redci za prikaz, po datumu knjizenja. Iznosi su
 * podijeljeni tecajem (exRate), kao i ostatak kartice.
 */
export const gradiRedke = (dokumenti, doDatuma, exRate) => {
  const k = exRate || 1
  return (dokumenti || [])
    .filter(d => d.otvoreno > 0.005)
    .sort((a, b) => (a.BookingDate > b.BookingDate ? 1 : (b.BookingDate > a.BookingDate ? -1 : a.id - b.id)))
    .map(d => {
      const dana = d.jeRacun ? danaOdDospijeca(d, doDatuma) : null
      return {
        kljuc: d.id,
        jeRacun: !!d.jeRacun,
        vrsta: d.jeRacun ? 'račun' : 'uplata',
        dokument: oznakaDokumenta(d),
        veza: vezaDokumenta(d),
        datum: d.BookingDate || '',
        datumTxt: datumTekst(d.BookingDate),
        datumDokTxt: datumTekst(d.InvoiceDate),
        // Dospijece ima smisla samo na racunu; na uplati je to datum izvoda.
        dospijece: d.jeRacun ? (d.InvoicePaymentDeadlineDate || '') : '',
        dospijeceTxt: d.jeRacun ? datumTekst(d.InvoicePaymentDeadlineDate) : '',
        dana: dana,
        razred: d.jeRacun ? razred(dana) : null,
        opis: d.Description || '',
        konto: d.account4 || '',
        partnerVATID: d.partnerVATID || '',
        partnerName: d.partnerName || '',
        iznos: n2(d.iznos / k),
        zatvoreno: n2(d.zatvoreno / k),
        otvoreno: n2(d.otvoreno / k)
      }
    })
}

// Tekuci saldo kroz redke onim redom kojim su prikazani.
export const saldaRedom = (redci) => {
  let saldo = 0
  return redci.map(r => {
    saldo = n2(saldo + (r.jeRacun ? r.otvoreno : -r.otvoreno))
    return Object.assign({}, r, {saldo: saldo})
  })
}

export const sazmi = (redci) => {
  const z = {racuna: 0, iznosRacuna: 0, uplata: 0, iznosUplata: 0, dospjelo: 0, najviseDana: null}
  RAZREDI.forEach(r => { z[r.k] = 0 })
  redci.forEach(r => {
    if (r.jeRacun) {
      z.racuna += 1
      z.iznosRacuna = n2(z.iznosRacuna + r.otvoreno)
      z[r.razred] = n2(z[r.razred] + r.otvoreno)
      if (r.dana !== null && r.dana > 0) {
        z.dospjelo = n2(z.dospjelo + r.otvoreno)
        if (z.najviseDana === null || r.dana > z.najviseDana) { z.najviseDana = r.dana }
      }
    } else {
      z.uplata += 1
      z.iznosUplata = n2(z.iznosUplata + r.otvoreno)
    }
  })
  z.saldo = n2(z.iznosRacuna - z.iznosUplata)
  return z
}
